export default "/images/vendor/flag-icon-css/flags/4x3/us.svg?cb3557fd707b978ef927bef888378fb8";